import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Practice } from '../models/practice';
import { PracticeInvitation } from '../models/practiceInvitation';
import { Account } from '../models/account';

@Injectable({
  providedIn: 'root'
})

export class PracticeService {
    constructor(private http: HttpClient) {
    }

    public deactivateMember(memberId:number):Observable<any>{
      return this.http.put(environment.apiEndpoint+`/api/user/deactivatePracticeMembership`, {memberId:memberId}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public activateMember(memberId:number):Observable<any>{
      return this.http.put(environment.apiEndpoint+`/api/user/activatePracticeMembership`, {memberId:memberId}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public createPracticeContent(): Observable<any>{
      return this.http.post(environment.apiEndpoint+'/api/admin/practice/contentUser', {name: 'New Practice Course'}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getPracticeContent(): Observable<any> {
      return this.http.get(environment.apiEndpoint+'/api/my-practice/content').pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getMyPractice(): Observable<any> {
        return this.http.get<Practice>(environment.apiEndpoint + `/api/my-practice`).pipe(
            map(res => {
                return new Practice(res);
            })
        );
    }

    public leavePractice(): Observable<any> {
        return this.http.get<Practice>(environment.apiEndpoint + `/api/leave-practice`).pipe(
            map(res => {
                return new Practice(res);
            })
        );
    }

    public getParentPractice(): Observable<any> {
        return this.http.get<Practice>(environment.apiEndpoint + `/api/parent-practice`).pipe(
            map(res => {
                return new Practice(res);
            })
        );
    }

    public createPractice(practice: Practice):Observable<Practice>{
        return this.http.post<Practice>(environment.apiEndpoint + `/api/practice`, practice).pipe(
            map(res => {
                return new Practice(res);
            })
        );
    }

    public updatePractice(practice:Practice):Observable<Practice>{
        return this.http.put<Practice>(environment.apiEndpoint + `/api/practice`, practice).pipe(
            map(res => {
                return new Practice(res);
            })
        );
    }

    public removeMember(member_id:number):Observable<any>{
        return this.http.delete<any>(environment.apiEndpoint + `/api/practice/member/${member_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public inviteMember(email:string):Observable<any>{
        return this.http.post<any>(environment.apiEndpoint + `/api/practice/member`,{email:email}).pipe(
            map(res => {
                return res;
            })
        );
    }

    public cancelInvitation(member_id:number):Observable<any>{
        return this.http.delete<any>(environment.apiEndpoint + `/api/practice/invitation/${member_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public removeMentor(mentor_id:number, practice_id:number):Observable<any>{
      return this.http.delete<any>(environment.apiEndpoint + `/api/removePracticeMentor/${practice_id}/${mentor_id}`).pipe(
          map(res => {
              return res;
          })
      );
    }

    public removeMemberMentor(memberId:number, mentorId:number):Observable<any>{
      return this.http.delete(environment.apiEndpoint+`/api/removeMemberMentor/${memberId}/${mentorId}`).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public assignMemberMentor(memberId:number, mentorId:number):Observable<any>{
      return this.http.post(environment.apiEndpoint+`/api/assignMemberMentor`, {memberId:memberId, mentorId:mentorId}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public inviteMentor(email:string, practiceId:number):Observable<any>{
      return this.http.post<any>(environment.apiEndpoint + `/api/practice/mentor`,{mentorEmail:email, practiceId:practiceId}).pipe(
          map(res => {
              return res;
          })
      );
    }

    public cancelMentorInvitation(invite_id:number):Observable<any>{
      return this.http.delete<any>(environment.apiEndpoint + `/api/practice/mentor-invitation/${invite_id}`).pipe(
          map(res => {
              return res;
          })
      );
  }

    public getMyInvitations():Observable<any>{
        return this.http.get<any>(environment.apiEndpoint + `/api/practice/my-invitations`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getMyMentorInvitations():Observable<any>{
        return this.http.get<any>(environment.apiEndpoint + `/api/practice/my-mentor-invitations`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public acceptInvitation(practiceInvitation:PracticeInvitation):Observable<any>{
        return this.http.post<PracticeInvitation>(environment.apiEndpoint + `/api/practice/accept-invitation`,practiceInvitation).pipe(
            map(res => {
                return res;
            })
        );
    }

    public acceptMentorInvitation(inviteId:number):Observable<any>{
      return this.http.post(environment.apiEndpoint + `/api/practice/accept-mentor-invitation`,{inviteId:inviteId}).pipe(
          map(res => {
              return res;
          })
      );
    }

    public declineInvitation(practiceInvitation:PracticeInvitation):Observable<any>{
        return this.http.post<PracticeInvitation>(environment.apiEndpoint + `/api/practice/decline-invitation`,practiceInvitation).pipe(
            map(res => {
                return res;
            })
        );
    }

    public declineMentorInvitation(inviteId:number):Observable<any>{
      return this.http.post(environment.apiEndpoint + `/api/practice/decline-mentor-invitation`,{inviteId:inviteId}).pipe(
          map(res => {
              return res;
          })
      );
  }

    public getMembers(){
        return this.http.get<Account[]>(environment.apiEndpoint + `/api/practice/member`).pipe(
            map(res => {
                let users=[];
                res.forEach(user=>{
                    users.push(new Account(user));
                })
                return users;
            })
        );
    }

    public updatePracticeBacsSeats(practiceId:number, quantity:number):Observable<any>{
      return this.http.put(environment.apiEndpoint+`/api/practice/bacs-seats`, {practiceId:practiceId, quantity:quantity, notify:environment.contactFormRecipient}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public registerInviteMember(email:string, first_name:string, last_name:string, role:string):Observable<any>{
      return this.http.post(environment.apiEndpoint+`/api/practice/registerInviteMember`,{email:email, first_name:first_name, last_name:last_name, role:role}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
}
